import React from 'react';
import { Link } from 'gatsby';

import CDNImage from "../cdn-image";

import '../../../styles/common/promos/prints-promo.scss';

const PrintsPromo = ({
	frameCount,
	inShoppingBar,
}) => (
	<div className={`framed-prints-promo ${inShoppingBar ? 'in-shopping-bar' : ''}`}>
		<Link to="/shop/fine-art-prints">
			<div className="images">
				<div>
					<CDNImage
						imagePath="/banners/prints-shop/prints-banner-1a.jpg"
						height="453"
						alt="Ancient Courses print"
						className="print-1"
					/>
				</div>
				{frameCount > 1 && (
					<div>
						<CDNImage
							imagePath="/banners/prints-shop/prints-banner-2.jpg"
							height="438"
							alt="Eight Shadow Figures print"
							className="print-2"
						/>
					</div>
				)}
				{frameCount > 2 && (
					<div className="hide-on-mobile">
						<CDNImage
							imagePath="/banners/prints-shop/prints-banner-3.jpg"
							height="386"
							alt="Blue Root print"
							className="print-3"
						/>
					</div>
				)}
				{frameCount > 3 && (
					<div className="full-size-only">
						<CDNImage
							imagePath="/banners/prints-shop/prints-banner-4.jpg"
							height="445"
							alt="Meteor Shower print"
							className="print-4"
						/>
					</div>
				)}
			</div>
			<div className="text-details">
				<span className="headline">Shop Our Range of Prints</span>
				<span className="message">Premium prints using pigment-based archival inks (Giclee process) on high grade heavyweight art paper. Available as unframed or framed and ready to hang.</span>
				<span className="shipping">Free Shipping to US, UK, EU, Canada, and Australia.</span>
			</div>
		</Link>
	</div>
);

export default PrintsPromo;